import useResource from "hooks/resources"
import { useAccountAlias } from "resources/account"

export interface Country {
  value: string
  label: string
  count: string
}

export function useModelCountries(modelId: string | null) {
  const account = useAccountAlias()
  return useResource<Country[] | null>({
    resource: "modelCountries",
    url: () => {
      if (!account || !modelId) {
        return null
      }
      return `/api/${account}/m/${modelId}/countries`
    },
  }, "modelCountries")
}
